import React from "react";

function Table({ distributors }: any) {
  if (distributors) {
    return (
      <table id="partners-table" style={{ overflow: "auto" }}>
        <thead>
          <tr
            style={{
              backgroundColor: "rgb(240, 244, 245)",
              fontWeight: 800,
              fontSize: "16px",
            }}
          >
            <td>Nazwa firmy</td>
            <td>Adres</td>
            <td className="hidden-xs">Województwo</td>
            <td>Telefon</td>
            <td>Adres e-mail</td>
          </tr>
        </thead>
        <tbody>
          {distributors.map((item: any, key: number) => {
            const rowBrand =
              item.name === "Firmowy punkt sprzedaży KAMAL"
                ? { backgroundColor: "#a53f0f", color: "#fff" }
                : {};
            return (
              <tr key={key} style={rowBrand}>
                <td>{item.name}</td>
                <td
                  dangerouslySetInnerHTML={{
                    __html:
                      item.miejscowosc + " " + item.kod + " " + item.adres,
                  }}
                />
                <td>{item.wojewudztwo}</td>
                <td>{item.telefon}</td>
                <td>{item.email}</td>
              </tr>
            );
          })}
          {!distributors.length ? (
            <tr>
              <td colSpan={5}>Brak dystrybutorów w wybranym województwie</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    );
  } else {
    return null;
  }
}

export default Table;
